/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFiretruck48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M24 32H8l-2 2.5h18V32zm0 0h16l2 2.5H24V32zM8.5 21H40l-1-5.5c-6.336.656-21.17 2.06-31 5l.5.5zM16 6h-2.515v3H16V6zm16 0h2.515v3H32V6z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M11 26.5h10M5.5 13h4.25'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M16.5 8.5l-.374-2.244a.905.905 0 00-.893-.756h-2.991a.905.905 0 00-.888.728l-.641 3.203'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M20 9l-1-7.5M19.5 3.5h5M20 6.5h7M3 36.844V26.53A5.53 5.53 0 018.53 21h30.94A5.53 5.53 0 0145 26.53v10.314M37 26.5H27'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M6 36.844V36a4 4 0 014-4h28a4 4 0 014 4v.844'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M9 41.5H3v3.553c0 .799.648 1.447 1.447 1.447h3.106C8.351 46.5 9 45.852 9 45.053V41.5zm30 0h6v3.553c0 .799-.648 1.447-1.447 1.447h-3.105c-.8 0-1.448-.648-1.448-1.447V41.5z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M8 20.5l1.617-8.89a2.57 2.57 0 012.528-2.11h23.71a2.57 2.57 0 012.529 2.11L40 20.5'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M9.5 13h29'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M11.5 36.844H1.698a.7.7 0 00-.698.699v3.258c0 .386.313.699.698.699h44.603a.699.699 0 00.699-.699v-3.258a.698.698 0 00-.699-.699H36.5M32.5 36.844h-17'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M42.5 13h-4.25'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M13.5 34.5a2 2 0 11-.001 4.001A2 2 0 0113.5 34.5zm21 0a2 2 0 10.001 4.001A2 2 0 0034.5 34.5zm-10-11c1.655 0 3 1.345 3 3s-1.345 3-3 3-3-1.345-3-3 1.345-3 3-3zm-16.25 1a2.25 2.25 0 11-.002 4.502A2.25 2.25 0 018.25 24.5zm31.5 0a2.25 2.25 0 10.002 4.502 2.25 2.25 0 00-.002-4.502zM5.5 13.387a.888.888 0 00-.888-.887H2.101A1.1 1.1 0 001 13.601v4.798A1.1 1.1 0 002.101 19.5h2.511c.49 0 .888-.398.888-.887v-5.226 0zm37 0c0-.49.398-.887.888-.887h2.511A1.1 1.1 0 0147 13.601v4.798a1.1 1.1 0 01-1.101 1.101h-2.511a.888.888 0 01-.888-.887v-5.226 0z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M31.5 8.5l.374-2.244a.905.905 0 01.893-.756h2.991c.431 0 .803.304.887.728l.642 3.203'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M28 9l1-7.5M28.5 3.5h-5M28 6.5h-7'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24.5 14.5v6'
      />
    </svg>
  );
}

export default SvgFiretruck48;
